const fieldCheckerService = {
  switchAndReturnField: (field: string) => {
    switch (field) {
      case 'bodyStyle':
        return 'bodyStyleCode';
      case 'engine':
        return 'engineCode';
      case 'model':
        return 'modelCode';
      case 'specificationPack':
        return 'specPackCode';
      case 'trim':
        return 'trimCode';
      case 'variant':
        return 'variantCode';

      default:
        return null;
    }
  },
};

export default fieldCheckerService;
